import { useState, useEffect } from "react";
import axios from "axios";
import { useRequireAdmin } from "@/lib/useRequireAdmin";

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const AdminWaitlist = () => {
  const { authChecked } = useRequireAdmin();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authChecked) fetchEntries();
  }, [authChecked]);

  const fetchEntries = async () => {
    try {
      const response = await axios.get(`${API}/waitlist`);
      setEntries(response.data);
    } catch (error) {
      console.error("Failed to fetch entries:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!authChecked) return null;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-xl text-gray-400">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8" style={{ background: '#1a1a1e' }}>
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-2" data-testid="admin-title">
            RGM Studio™ Waitlist
          </h1>
          <p className="text-gray-400">Total Entries: {entries.length}</p>
        </div>

        <div className="space-y-4">
          {entries.map((entry) => (
            <div
              key={entry.id}
              className="admin-card"
              data-testid={`entry-${entry.id}`}
              style={{
                background: 'rgba(42, 26, 58, 0.5)',
                border: '1px solid rgba(138, 43, 226, 0.2)',
                borderRadius: '12px',
                padding: '1.5rem',
                backdropFilter: 'blur(10px)'
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-400 mb-1">Name</p>
                  <p className="text-white font-semibold" data-testid="entry-name">{entry.name}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Artist Name</p>
                  <p className="text-white font-semibold" data-testid="entry-artist-name">{entry.artist_name}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <p className="text-white" data-testid="entry-email">{entry.email}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Submitted</p>
                  <p className="text-white" data-testid="entry-timestamp">
                    {new Date(entry.timestamp).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <p className="text-sm text-gray-400 mb-1">What they want to improve</p>
                <p className="text-white" data-testid="entry-improvement">{entry.improvement_area}</p>
              </div>
            </div>
          ))}

          {entries.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-400 text-lg">No waitlist entries yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminWaitlist;
